import { useState } from "react";
import { GTFSCalendar } from "../../components/Calendar";
import { InputNumber } from "primereact/inputnumber";
import { ProgressSpinner } from "primereact/progressspinner";
import { useQueryGtfsResourceById } from "../../Queries";
import { gtfsFormatDateToYYYYMMDD, gtfsParseYYYYMMDD } from "../../helpers/gtfsDateUtils";



export function Calendars({serviceId}) {
    const now = new Date();
    const [year, setYear] = useState(now.getFullYear())
    const {data, isPending, error} = useQueryGtfsResourceById('calendars',serviceId);

    if (isPending) {
      return (<ProgressSpinner />);
    }
  
    if (error) {
      return <>{error.message}</>;
    }

    function getDayClass(year, month, day) {
        // todo: oznaczenie świąt w kalendarzu, jak np. tu:
        // if(month == 11 && day == 25) return 'holiday';

        const date = new Date(year, month, day);

        if(date < gtfsParseYYYYMMDD(data.start_date)) return 'out-of-range';

        if(date > gtfsParseYYYYMMDD(data.end_date)) return 'out-of-range';

        if( data.exceptions_dates_removed.includes(gtfsFormatDateToYYYYMMDD(date)) ) return 'does-not-run-as-exception';

        if( data.exceptions_dates_added.includes(gtfsFormatDateToYYYYMMDD(date)) ) return 'runs-as-exception';

        if (
            (data.monday === true && date.getDay() === 1)
        ||  (data.tuesday === true && date.getDay() === 2)
        ||  (data.wednesday === true && date.getDay() === 3)
        ||  (data.thursday === true && date.getDay() === 4)
        ||  (data.friday === true && date.getDay() === 5)
        ||  (data.saturday === true && date.getDay() === 6)
        ||  (data.sunday === true && date.getDay() === 0)          
        ) return 'normally-runs';

        return 'normally-does-not-run';
    }

    return (
        <>
            <div className="w-full flex justify-content-center">
            <InputNumber 
                value={year} 
                onValueChange={(e) => setYear(e.value)} 
                showButtons 
                buttonLayout="horizontal"
                incrementButtonIcon="fa-solid fa-chevron-right" 
                decrementButtonIcon="fa-solid fa-chevron-left"
                useGrouping={false}
                />
            </div>
            <GTFSCalendar year={year} key={serviceId} getDayClass={getDayClass} />
        </>
    );
}
